import React from 'react';
import ExpandableInteractiveTimeReportFilters from 'components/templates/rpm/practice/interactiveReportV2/expandable-filters';
import InteractiveTimeReportHeader from 'components/templates/rpm/practice/interactiveReportV2/header';
import InteractiveTimeReportTable from 'components/templates/rpm/practice/interactiveReportV2/table';
import { useInteractiveTimeDashboardData } from 'infrastructure/hooks/interactiveTimeDashboard/useData';
import { useInteractiveTimeDashboardFilters } from 'infrastructure/hooks/interactiveTimeDashboard/useFilters';
import { useInteractiveTimeDashboardSendReport } from 'infrastructure/hooks/interactiveTimeDashboard/useSendReport';
import useUser from 'utils/useUser';

const InteractiveTimeReportV2: React.FC = () => {
  const { resetFilters, appendFilters, changePage, filters, filtersCount } =
    useInteractiveTimeDashboardFilters({
      interactionFlagStartTime: null,
      interactionFlagEndTime: null,
    });
  const { isMedicalAssistantRole } = useUser();
  const { data, isLoading } = useInteractiveTimeDashboardData({
    ...filters,
    allowCriticals: isMedicalAssistantRole ? true : undefined,
  });
  const { isLoading: sendReportIsLoading, sendReportToEmail } =
    useInteractiveTimeDashboardSendReport(filters);

  return (
    <>
      <InteractiveTimeReportHeader
        sendReportIsLoading={sendReportIsLoading}
        sendReportToEmail={sendReportToEmail}
      />
      <ExpandableInteractiveTimeReportFilters
        data={filters}
        count={filtersCount}
        updateFilter={appendFilters}
        resetFilter={resetFilters}
      />
      <InteractiveTimeReportTable
        interactiveTime={data}
        filters={filters}
        isLoading={isLoading}
        changePage={changePage}
      />
    </>
  );
};

export default InteractiveTimeReportV2;
